import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const MockupLocation = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../../images/location_feature.png"
      alt="collar inteligente Kolyy"
    />
  );
};

export default MockupLocation;
